import { Brand, brandDisplayName } from 'common/Brand';
import { META_DESCRIPTION, TABLERUN_META_DESCRIPTION, TABLERUN_TITLE, TITLE } from 'src/shared/Constants';
import { match } from 'ts-pattern';

export interface BrandPageMeta {
  title: string;
  description: string;
}

export interface BrandPageMetaParams {
  brand: Brand;
  isDev: boolean;
  isStaging: boolean;
}

const PRODUCTION_META: Record<Brand, BrandPageMeta> = {
  [Brand.Shef]: { title: TITLE, description: META_DESCRIPTION },
  [Brand.TableRun]: { title: TABLERUN_TITLE, description: TABLERUN_META_DESCRIPTION },
};

export function brandPageMeta({ brand, isDev, isStaging }: BrandPageMetaParams): BrandPageMeta {
  const { title, description } = PRODUCTION_META[brand];

  return {
    title: match({ isDev, isStaging })
      .with({ isDev: true }, () => `${brandDisplayName(brand)} | localhost`)
      .with({ isStaging: true }, () => `${brandDisplayName(brand)} | staging`)
      .otherwise(() => title),
    description,
  };
}
